import { lazyNamed } from "src/utils/lazy-named";

import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";

const Fivetran = lazyNamed(() => import("./fivetran"), "Fivetran");
const FivetranConfiguration = lazyNamed(
  () => import("./fivetran"),
  "FivetranConfiguration",
);
const FivetranOverview = lazyNamed(
  () => import("./fivetran"),
  "FivetranOverview",
);
const DbtModels = lazyNamed(() => import("./dbt-models"), "DbtModels");
const DbtModelsConfiguration = lazyNamed(
  () => import("./dbt-models"),
  "DbtModelsConfiguration",
);
const DbtModelsOverview = lazyNamed(
  () => import("./dbt-models"),
  "DbtModelsOverview",
);
const DbtModelsSourceForm = lazyNamed(
  () => import("./dbt-models"),
  "DbtModelsSourceForm",
);
const DbtCloud = lazyNamed(() => import("./dbt-cloud"), "DbtCloud");
const DbtCloudConfiguration = lazyNamed(
  () => import("./dbt-cloud"),
  "DbtCloudConfiguration",
);
const DbtCloudOverview = lazyNamed(
  () => import("./dbt-cloud"),
  "DbtCloudOverview",
);
const Looker = lazyNamed(() => import("./looker"), "Looker");
const LookerConfiguration = lazyNamed(
  () => import("./looker"),
  "LookerConfiguration",
);
const LookerOverview = lazyNamed(() => import("./looker"), "LookerOverview");
const Alerting = lazyNamed(() => import("./alerting"), "Alerting");
const AlertingConfiguration = lazyNamed(
  () => import("./alerting"),
  "AlertingConfiguration",
);
const AlertingOverview = lazyNamed(
  () => import("./alerting"),
  "AlertingOverview",
);
const GitSync = lazyNamed(() => import("./git-sync"), "GitSync");
const GitSyncConfiguration = lazyNamed(
  () => import("./git-sync"),
  "GitSyncConfiguration",
);
const GitSyncOverview = lazyNamed(
  () => import("./git-sync"),
  "GitSyncOverview",
);
const GitSyncRuns = lazyNamed(() => import("./git-sync"), "GitSyncRuns");
const GitSyncVerifyInstallation = lazyNamed(
  () => import("./git-sync-verify-installation"),
  "GitSyncVerifyInstallation",
);
const DbtModelsVerifyInstallation = lazyNamed(
  () => import("./git-sync-verify-installation"),
  "DbtModelsVerifyInstallation",
);
const Sigma = lazyNamed(() => import("./sigma"), "Sigma");
const SigmaConfiguration = lazyNamed(
  () => import("./sigma"),
  "SigmaConfiguration",
);
const SigmaOverview = lazyNamed(() => import("./sigma"), "SigmaOverview");
const Monitoring = lazyNamed(() => import("./monitoring"), "Monitoring");
const MonitoringConfiguration = lazyNamed(
  () => import("./monitoring"),
  "MonitoringConfiguration",
);
const MonitoringOverview = lazyNamed(
  () => import("./monitoring"),
  "MonitoringOverview",
);
const extensionsImport = () => import("./extensions");
const Extensions = lazyNamed(extensionsImport, "Extensions");

export const preloads: RoutePreload[] = [["/extensions", extensionsImport]];

export const routes: Array<RouteObject> = [
  {
    path: "extensions",
    element: <Extensions />,
    spacesAccess: "hidden-from-limited-view",
  },
  {
    path: "extensions/fivetran/*",
    element: <Fivetran />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <FivetranOverview />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration",
        element: <FivetranConfiguration />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
  {
    path: "extensions/dbt-models/*",
    element: <DbtModels />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <DbtModelsOverview />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration/*",
        element: <DbtModelsConfiguration />,
        spacesAccess: "hidden-from-limited-view",
        children: [
          {
            path: ":sourceId",
            element: <DbtModelsSourceForm />,
            spacesAccess: "hidden-from-limited-view",
          },
        ],
      },
      {
        path: "configuration/verify-installation",
        element: <DbtModelsVerifyInstallation />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
  {
    path: "extensions/dbt-cloud/*",
    element: <DbtCloud />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <DbtCloudOverview />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration",
        element: <DbtCloudConfiguration />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
  {
    path: "extensions/looker/*",
    element: <Looker />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <LookerOverview />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration",
        element: <LookerConfiguration />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
  {
    path: "extensions/alerting/*",
    element: <Alerting />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <AlertingOverview />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration",
        element: <AlertingConfiguration />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
  {
    path: "extensions/git-sync/*",
    element: <GitSync />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <GitSyncOverview />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration",
        element: <GitSyncConfiguration />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration/verify-installation",
        element: <GitSyncVerifyInstallation />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "runs",
        element: <GitSyncRuns />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
  {
    path: "extensions/sigma/*",
    element: <Sigma />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <SigmaOverview />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration",
        element: <SigmaConfiguration />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
  {
    path: "extensions/monitoring/*",
    element: <Monitoring />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        element: <MonitoringOverview />,
        spacesAccess: "hidden-from-limited-view",
      },
      {
        path: "configuration",
        element: <MonitoringConfiguration />,
        spacesAccess: "hidden-from-limited-view",
      },
    ],
  },
];
